import MobileDevice from '@/models/MobileDevice/MobileDevice';

export default class MobileDeviceFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.name = '';
		this.identifierCode = '';
		this.boundToPrinterId  = '';
		this.boundToPrinterName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			name : '0',
			identifierCode : '0',
			boundToPrinterId : '0',
			boundToPrinterName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}